export default __webpack_public_path__ + "static/media/Pink_Player_Podium_min.bd54d45d.png";